import { atom } from "jotai";

export const filterSidebarAtom = atom<boolean>(true);

export const toggleFilterSidebarAtom = atom(null, (get, set) => {
  set(filterSidebarAtom, !get(filterSidebarAtom));
});
